import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { fetchMyPreferredProgrammes, unloadMyPreferredProgrammes } from "../../../../redux/actions/preferred-programs";
import { isRolePlatformAdmin, token } from "../../../../modules/auth";
import Loading from "../../../../Components/Loading";
import { Link } from "react-router-dom";
import * as ROUTES from "../../../../Router/corporate_routes";
import { ButtonBrand } from "../../../../Components/Button";
import { AgencyBadge, CompanyBadge } from "../../../../ui/EDGEBadges";

function PreferredProgrammeFilterPage({
                                        token,
                                        fetchMyPreferredProgrammes,
                                        myPreferredProgrammes,
                                        isFetchingMyPreferredProgrammes,
                                        unloadMyPreferredProgrammes,
                                        isPlatformAdmin,
                                      }) {
  useEffect(() => {
    fetchMyPreferredProgrammes(token);
    return () => unloadMyPreferredProgrammes();
  }, []);

  const getPreferredProgrammesOptions = useCallback(() => {
    let options = [];
    myPreferredProgrammes.forEach(programme => {
      options.push({
        text: programme.name.replace(" Preferred Programme", ""),
        value: programme.id,
        isAgency: programme.name.toString().indexOf("Agency") > -1,
        companyId: programme?.company_id || null,
        agencyId: programme?.agency_id || null,
      });
    });
    options.sort((a, b) => {
      if (a.isAgency !== b.isAgency) {
        return a.isAgency ? -1 : 1;
      }
      return a.text.localeCompare(b.text);
    });
    return options;
  }, [myPreferredProgrammes]);

  const getReportLink = useCallback(
    preferredProgramme => {
      const selectedPreferredProgramme = myPreferredProgrammes.find(
        programme => Number(programme.id) === Number(preferredProgramme),
      );

      const basePath = isPlatformAdmin ? ROUTES.FRONTEND.AGENCY.REPORTS.PREFERRED_PROGRAMME_SPEND :
        ROUTES.FRONTEND.AGENCY.REPORTS.PREFERRED_PROGRAMME_SPEND.replace(
          "agency/",
          "",
        );
      const { agency_id: agencyId, company_id: companyId } = selectedPreferredProgramme || {};
      const queryParams = new URLSearchParams({
        preferredProgramme: selectedPreferredProgramme?.id,
      });
      if (agencyId !== null) {
        queryParams.set("agencyId", agencyId);
      }
      if (companyId !== null) {
        queryParams.set("companyId", companyId);
      }

      return `${basePath}?${queryParams.toString()}`;
    },
    [myPreferredProgrammes],
  );

  if (isFetchingMyPreferredProgrammes) {
    return <Loading />;
  }

  return (
    <div className="py-5">
      <div className="md:flex md:justify-between mb-5">
        <h1>Preferred Programme Spend Reports</h1>
      </div>
      <div className="flex flex-row flex-wrap -mx-2">
        {getPreferredProgrammesOptions().map(({ text, value, isAgency }) => {
          console.log(text)

          return (
            <div
              key={value}
              className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 p-2 mb-3"
            >
              <div className="bg-white h-full p-5 flex flex-col">
                {/*<h2 className="mb-4 text-center">{text}</h2>*/}
                <p className="flex-1 text-center font-bold">{text}</p>
                <p className="flex-1 text-center mb-5">
                  {isAgency ? <AgencyBadge /> : <CompanyBadge />}
                </p>
                <Link to={getReportLink(value)}>
                  <ButtonBrand classes="w-full">View Report</ButtonBrand>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    token: token(state),
    isPlatformAdmin: isRolePlatformAdmin(state),
    ...state.myPreferredProgrammes,
  };
};

const mapDispatchToProps = {
  fetchMyPreferredProgrammes,
  unloadMyPreferredProgrammes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreferredProgrammeFilterPage);
